import {IPlugin} from '../IPlugin';
import {BasePlugin} from './BasePlugin';
import {UriHelper, FileUtils, StringUtils, ArrayUtils, Logger, Utils} from 'neo-common';
import {AppContextBase} from '../../../GameEngine';

export class PeakTournaments extends BasePlugin {

    private static restrictedGames: Array<string> = ['EuropeanRoulette', 'EuropeanRouletteVip','FireWitchX'];

    public init(): void {

        let isRestricted: boolean = PeakTournaments.restrictedGames.indexOf(AppContextBase.getInstance().gameKey) !== -1;
        if (isRestricted) return;
        if (!this.validateUrl(this._pluginUrl)) {
            this.log(`PluginUrl - ${this._pluginUrl} is not valid`);
            return;
        }

        const _self = this;
        const versionPath = UriHelper.setTimeStamp(this._pluginUrl.replace('index.js','version.txt'));
        FileUtils.readLocalFile(versionPath, 'text', false)
            .then(response => {
                _self.versionLoaded(response);
            });

        this.log(`Load version.txt`);
    }

    protected versionLoaded(response: string): void {
        let timestamp = Date.now().toString();
        if (!StringUtils.isNullOrEmpty(response)) {
            const versionData = ArrayUtils.stringArray(response, '|');
            if (versionData.length === 2) {
                timestamp = versionData[1];
            }
        }

        let script = document.createElement('script');
        script.setAttribute('type', 'text/javascript');
        script.setAttribute('src', UriHelper.setTimeStamp(this._pluginUrl, timestamp));
        script.setAttribute('type', 'module');
        script.onload = this.onPluginLoaded.bind(this, this._instanceName);
        document.head.appendChild(script);

        this.log(`Loading plugin started`);
    }

    protected onPluginLoaded(instanceName: string): void {
        if (window[instanceName] === null) {
            this.log(`Instance - ${instanceName} was not found`);
            return;
        }

        const instance = window[instanceName] as IPlugin;
        instance.init(this._clientHub, this._clientEvents, {
            panelIconPlaceholderId: 'peakIconHolder',
            menuIconPlaceholderId: 'peakMenuBtn',
            contentPlaceholderId: 'peakContentHolder',
            tournamentEventTrackerEnabled: this._configuration.TournamentEventTrackerEnabled,
            gameCode: AppContextBase.getInstance().gameKey
        });

        this.log(`Plugin loaded, call init: panelIconPlaceholderId: peakIconHolder, menuIconPlaceholderId: peakMenuBtn, 
        contentPlaceholderId: peakContentHolder, tournamentEventTrackerEnabled: ${this._configuration.TournamentEventTrackerEnabled.toString()}
        , gameCode: ${AppContextBase.getInstance().gameKey}`);

        if (this._callStart && !this._started) {
            this.gameStarted(this._startData);
        }

        if (this._idle) {
            //if the game is in idle state, call roundInit,
            //because roundInit was called before the plugin was loaded
            this.roundInit().then(value => {});
        }
    }

    protected log(s: string): void {
        if (DEBUG) {
            Logger.debugGroup('PeakTournaments', 'PeakTournaments ' + s);
        }
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Plugins/PlayerRetention/Plugins/PeakTournaments.ts
 **/